import * as filterEnum from "enums/filterEnum"
import { ContainmentHoldDTO } from "models/dto/containmentHold"

const dropdown = filterEnum.Dropdown<"containmentSubsequentHold", ContainmentHoldDTO>

export const Dropdown = () =>
	dropdown({
		field: "containmentSubsequentHold",
		getter: ({ api }) => api().ContainmentSubsequentHolds(),
		label: "Containment Hold Options",
	})
